import { css } from "styled-components";

/* ------------------------------------------------------------------ */
/*  공통 반응형 브레이크포인트 (헤더 / 콘텐츠 등 전역 단일 소스)        */
/*  기기 구분은 width(표준), 태블릿 가로/세로는 orientation으로 구분.  */
/*  - mobile      : width ~ 767px                                      */
/*  - tablet 세로 : width 768~1366 + 세로(portrait)                    */
/*  - tablet 가로 : width 768~1366 + 가로(landscape)                   */
/*  - pc          : width 1367px ~                                     */
/* ------------------------------------------------------------------ */
export const mobile = "@media (max-width: 767px)";
export const tabletP =
  "@media (min-width: 768px) and (max-width: 1366px) and (orientation: portrait)";
export const tabletL =
  "@media (min-width: 768px) and (max-width: 1366px) and (orientation: landscape)";
export const pc = "@media (min-width: 1367px)";
/* 768~1366 (태블릿 세로+가로 공통) */
export const tablet = "@media (min-width: 768px) and (max-width: 1366px)";

/* ------------------------------------------------------------------ */
/*  좌우 패딩 단일 소스 — 헤더와 콘텐츠가 동일하게 사용해 정렬 일치.   */
/* ------------------------------------------------------------------ */
export const PADX = { pc: 32, tabletL: 24, tabletP: 20, mobile: 16 };

/* 좌우 패딩만 적용하는 css 스니펫 (상하 패딩은 각자 지정) */
export const paddingX = css`
  ${pc} {
    padding-left: ${PADX.pc}px;
    padding-right: ${PADX.pc}px;
  }
  ${tabletL} {
    padding-left: ${PADX.tabletL}px;
    padding-right: ${PADX.tabletL}px;
  }
  ${tabletP} {
    padding-left: ${PADX.tabletP}px;
    padding-right: ${PADX.tabletP}px;
  }
  ${mobile} {
    padding-left: ${PADX.mobile}px;
    padding-right: ${PADX.mobile}px;
  }
`;
